import routerOptions0 from "/builds/devhacker/burninghut/bh-frontend/node_modules/.pnpm/nuxt@3.21.0_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler-sfc@3.5.27_db0@0.3.4_51fc68ec7fef33e5961eb3d70ac4e390/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}